import * as React from "react";
import { useCallback } from "react";
import { TextField } from "@mui/material";
export function useRenderInput(props) {
    const { fullWidth, helperText, size, required } = props;
    return useCallback((props) => (React.createElement(TextField, Object.assign({ variant: "outlined", fullWidth: fullWidth, helperText: helperText, size: size, required: required }, props))), [fullWidth, helperText, size]);
}
//# sourceMappingURL=useRenderInput.js.map